


































// vendor
import { defineComponent, computed, ref } from "@vue/composition-api";
// project
import * as Info from "@/info";

export default defineComponent({
	props:{
		show:{
			type:Boolean,
			default:true
		},
		loading:{
			type:Boolean,
			default:true
		},
	},
	setup(){
		const logo = computed(() => Info.companyLogo);
		const slogan = computed(() => `<span>Powered by </span><b style="font-weight:bold">${Info.companyName}</b>`);
		return {
			logo,
			slogan,
		};
	}
});

